import { round, getOption, setInputFilter } from '../../../helper-functions'

/**
 * Manages calculator functionality.
 */
export default function manageMxCalculator () {
  const calculators = document.querySelectorAll( '.js-mx-calc' )
  const cofferConstantV = .3

  calculators.forEach( calc => {
    const loader = calc.querySelector( '.js-calc-loader' )
    const reset = calc.querySelector( '.js-calc-reset' )
    const slabList = calc.querySelector( '.js-slab-list' )
    const subtotalVol = calc.querySelector( '.js-subtotal-vol' )
    const coffersVol = calc.querySelector( '.js-coffers-vol' )
    const wasteVol = calc.querySelector( '.js-waste-vol' )
    const totalVol = calc.querySelector( '.js-total-vol' )
    const calcResult = calc.querySelector( '.js-calc-result' )
    const inputs = Array.from( calc.querySelector( '.js-calc-inner' ).getElementsByTagName( 'input' ) )
    const unitOptions = calc.querySelectorAll( 'input[name="unit-option"]' )
    const closeSettings = calc.querySelector( '.js-close-settings' )
    const calcSettings = calc.querySelector( '.js-calc-settings' )
    const calcSettingsWrapper = calc.querySelector( '.js-calc-settings-wrapper' )

    if ( calc.querySelector( '.calc-waste-setting' ) ) {
      calc.querySelector( '.calc-waste-setting' ).classList.add( 'hidden' )
    }

    const slabListItems = []
    const resetSlabForm = () => {
      inputs.forEach( input => {
        input.value = ''
      })
    }

    const resetSummary = () => {
      subtotalVol.innerHTML = ''
      coffersVol.innerHTML = ''
      wasteVol.innerHTML = ''
      totalVol.innerHTML = ''
      calcResult.innerHTML = '00'
      slabList.innerHTML = ''
      loader.classList.add( 'hidden' )
    }

    const refreshSlabs = () => {
      const unit = getOption( unitOptions )
      const qtyUnit = unit.startsWith( 'unit-us' ) ? 'pcs.' : 'pzas.'
      const smUnit = unit.startsWith( 'unit-us' ) ? 'in' : 'cm'
      const mdUnit = unit.startsWith( 'unit-us' ) ? 'in' : 'm'

      slabList.innerHTML = ''
      let subtotalValue = 0
      let coffersValue = 0
      let wasteValue = 0

      slabListItems.forEach( ( slab, idx ) => {
        const cofferType = unit.startsWith( 'unit-us' ) ? slab.coffer_type * 1 : slab.coffer_type * 100
        const slabVol = slab.length * slab.width * slab.depth
        const cofferVol = slab.coffer_qty * slab.coffer_type * cofferConstantV
        const slabWaste = ( slabVol - cofferVol ) * slab.coffer_percent

        subtotalValue += slabVol
        coffersValue += cofferVol
        wasteValue += slabWaste

        const listRow = `<div id="js-calc-row-${idx}">`
          + `<div>${round( slab.length, 2 )}<span class="js-md-unit">${mdUnit}</span></div>`
          + `<div>${round( slab.width, 2 )}<span class="js-md-unit">${mdUnit}</span></div>`
          + `<div>${round( slab.depth, 2 )}<span class="js-md-unit">${mdUnit}</span></div>`
          + `<div>${round( slabVol, 2 )}<span class="js-md-unit">${mdUnit}</span><sup>3</sup></div>`
          + `<div>${round( cofferVol, 2 )}<span class="js-md-unit">${mdUnit}</span><sup>3</sup> `
          + `(${slab.coffer_qty} <span class="js-qty-unit">${qtyUnit}</span>/${cofferType}`
          + `<span class="js-sm-unit">${smUnit}</span>)</div>`

        slabList.innerHTML += listRow
      })

      const totalValue = subtotalValue - coffersValue + wasteValue
      subtotalVol.innerHTML = `${round( subtotalValue, 2 )}<span class="js-md-unit">${mdUnit}</span><sup>3</sup>`

      coffersVol.innerHTML = `${round( coffersValue, 2 )}<span class="js-md-unit">${mdUnit}</span><sup>3</sup>`
      wasteVol.innerHTML = `${round( wasteValue, 2 )}<span class="js-md-unit">${mdUnit}</span><sup>3</sup>`
      totalVol.innerHTML = `${round( totalValue, 2 )}<span class="js-md-unit">${mdUnit}</span><sup>3</sup>`
      calcResult.innerHTML = round( totalValue, 2 )
    }

    // Set input filter.
    inputs.forEach( input => {
      if ( input.classList.contains( 'js-calc-coffer-total' ) ) {
        setInputFilter( input, function inputFilter ( value ) {
          return /^\d*\d*$/.test( value ) // Allow digits and '.' only
        })
      } else {
        setInputFilter( input, function inputFilter ( value ) {
          return /^\d*\.?\d*$/.test( value ) // Allow digits and '.' only
        })
      }
    })

    // Reset calculator.
    reset.onclick = () => {
      resetSlabForm()
      resetSummary()
      slabListItems.splice( 0, slabListItems.length )
    }

    // Add slab button.
    calc.querySelector( '.js-add-slab' ).onclick = () => {
      const hasValue = input => input.value

      if ( !inputs.every( hasValue ) ) {
        return 
      }

      slabListItems.push({
        length: parseFloat( calc.querySelector( '.js-calc-length' ).value ),
        width: parseFloat( calc.querySelector( '.js-calc-width' ).value ),
        depth: parseFloat( calc.querySelector( '.js-calc-depth' ).value ),
        coffer_type: parseFloat( calc.querySelector( '.js-calc-coffer-type' ).value ),
        coffer_qty: parseInt( calc.querySelector( '.js-calc-coffer-total' ).value ),
        coffer_percent: parseFloat( calc.querySelector( '.js-calc-coffer-waste' ).value ),
      })

      resetSlabForm()
      refreshSlabs()
    }

    // Open settings add opacity to calculator.
    calc.querySelector( '.js-open-settings' ).onclick = () => {
      calcSettingsWrapper.classList.remove( 'hidden' )

      setTimeout( () => {
        calcSettingsWrapper.classList.remove( 'bg-transparent' )
        calcSettingsWrapper.classList.add( 'bg-black-overlay' )
        calcSettings.classList.add( 'top-0' )
        calcSettings.classList.remove( '-top-100%' )
      }, 100 )
    }

    // Close settings and update calculator.
    closeSettings.onclick = () => {
      const unit = getOption( unitOptions )
      updateUnits( unit, calc )

      calcSettingsWrapper.classList.add( 'bg-transparent' )
      calcSettingsWrapper.classList.remove( 'bg-black-overlay' )
      calcSettings.classList.remove( 'top-0' )
      calcSettings.classList.add( '-top-100%' )

      setTimeout( () => {
        calcSettingsWrapper.classList.add( 'hidden' )
      }, 200 )
    }
  })

  /**
   * Updates DOM based on measurement system.
   *
   * @param {string} unit - The measurement system selected.
   * @param {object} calc - The calculator object to update.
   */
  function updateUnits ( unit, calc ) {
    const unitSm = calc.querySelectorAll( '.js-sm-unit' )
    const unitMd = calc.querySelectorAll( '.js-md-unit' )

    // Loop through calculator units
    unitSm.forEach( e => {
      e.innerText = unit.startsWith( 'unit-us' ) ? 'ft' : 'cm'
    })

    unitMd.forEach( e => {
      e.innerText = unit.startsWith( 'unit-us' ) ? 'ft' : 'm'
    })
  }
}